module.exports = __webpack_public_path__ + "img/seremban.58407e03.png";